import { apiSlice } from "../services/apiSlice";

export const gameApi = apiSlice
    .enhanceEndpoints({
        tagTypes: ["game"],
    })
    .injectEndpoints({
        endpoints: (builder) => ({
            getAllGames: builder.query({
                query: (params) => {
                    return {
                        url: `/admin/game`,
                        method: "GET",
                        params
                    };
                },
            }),
            getAllSubGamesByGameSlug: builder.query({
                query: ({ slug, params }) => {
                    return {
                        url: `/admin/game/${slug}`,
                        method: "GET",
                        params
                    };
                },
            }),
            getGameStatsByGameSlug: builder.query({
                query: ({ slug, params }) => {
                    return {
                        url: `/admin/game/${slug}/stats`,
                        method: "GET",
                        params
                    };
                },
            }),
            getGameUsersStatsByGameSlug: builder.query({
                query: ({ slug, params }) => {
                    return {
                        url: `/admin/game/${slug}/user/stats`,
                        method: "GET",
                        params
                    };
                },
            }),

            getSubGameStatsByGameSlug: builder.query({
                query: ({ game_slug, theme_slug, params }) => {
                    return {
                        url: `/admin/game/${game_slug}/${theme_slug}/stats`,
                        method: "GET",
                        params
                    };
                },
            }),
            getSubGameUsersStatsByGameSlug: builder.query({
                query: ({ slug, theme_slug, params }) => {
                    return {
                        url: `/admin/game/${slug}/${theme_slug}/user/stats`,
                        method: "GET",
                        params
                    };
                },
            }),
        }),
    });

export const {
    useGetAllGamesQuery,
    useGetAllSubGamesByGameSlugQuery,
    useGetGameStatsByGameSlugQuery,
    useGetGameUsersStatsByGameSlugQuery,
    useGetSubGameStatsByGameSlugQuery,
    useGetSubGameUsersStatsByGameSlugQuery
} = gameApi;
